export type ZoneKey = 'adopt' | 'trial-and-assess' | 'hold' | 'retire';

export type RingData = {
  key: ZoneKey;
  name: string;
  color: string;
  width: number;
  blipOpacity: number;
  description: string;
};

export const RINGS: RingData[] = [
  {
    key: 'adopt',
    name: 'Adopt',
    color: '#0AA134',
    width: 52,
    blipOpacity: 1,
    description:
      'Trusted, scalable technologies with proven production use, low risk, and widespread adoption. Clear ownership, end-to-end management, and supported by dedicated teams.',
  },
  {
    key: 'trial-and-assess',
    name: 'Trial & Assess',
    color: '#169DB0',
    width: 96,
    blipOpacity: 0.8,
    description:
      'Promising, project-suitable technologies with clear value for H&M Group - either experimental or industry standards, new to H&M. Adoption is trial-based, evaluated by benefits, commercial impact, and comparison to existing solutions.',
  },
  {
    key: 'hold',
    name: 'Hold',
    color: '#BD8100',
    width: 44,
    blipOpacity: 0.6,
    description:
      'Technologies that should generally be avoided for new projects but may be used in existing ones. This zone includes phased-out technologies.',
  },
  {
    key: 'retire',
    name: 'Retire',
    color: '#BA0138',
    width: 52,
    blipOpacity: 0.4,
    description:
      'Technologies with an active decommission decision to phase out from H&M Group. Teams must cease use unless a specific decommission notice states otherwise. The tool is not centrally supported.',
  },
];

export const RINGS_BY_KEY: Record<ZoneKey, RingData> = Object.fromEntries(
  RINGS.map(ring => [ring.key, ring]),
) as Record<ZoneKey, RingData>;
